import React, { useEffect, useState } from 'react'
import { useBlackFriday } from 'src/contexto/hooks/useBlackFriday'

export const IconeUsuario = '/images/svg/user.svg'

import { autenticado } from '../../services/auth'
import { HeaderDefault } from './layouts/HeaderDefault'

export default function Header({
  initialColor,
  finalColor,
  textColor,
  buttonColor,
  baseColor,
  buttonCartTextColor,
}) {
  const [sidebar, setSidebar] = useState(false)
  const [logado, setAutenticado] = useState(false)
  const [showZipcodeBox, setShowZipcodeBox] = useState(false)
  const { isBlackFridayTheme } = useBlackFriday()

  useEffect(() => {
    setAutenticado(autenticado())
  }, [])

  useEffect(() => {
    const overlay = document.querySelector('.overlay')
    if (sidebar) {
      const dropCarrinho = document.querySelector('header .area-cart')
      const dropTelefone = document.querySelector('header .telefone-contato')
      const dropUsuario = document.querySelector('header .area-user')

      dropCarrinho.classList.remove('active')
      dropTelefone.classList.remove('active')
      dropUsuario.classList.remove('active')

      if (overlay) {
        return overlay.classList.add('active')
      }
    }
    if (overlay) {
      return !sidebar ? overlay.classList.remove('active') : null
    }
  }, [sidebar])

  useEffect(() => {
    listener()
  })

  const activeDropdownUser = (e) => {
    e.preventDefault()

    const dropCarrinho = document.querySelector('header .area-cart')

    const overlay = document.querySelector('.overlay')
    const botao = document.querySelector('.btn-user')

    dropCarrinho.classList.remove('active')
    overlay.classList.toggle('active')

    botao.parentElement.classList.toggle('active')
    !botao.parentElement.classList.contains('active')
      ? overlay.classList.remove('active')
      : overlay.classList.add('active')
  }
  const hideDropdownUser = () => {
    const dropUsuario = document.querySelector('header .area-user')
    const overlay = document.querySelector('.overlay')

    overlay.classList.remove('active')
    dropUsuario.classList.remove('active')
  }

  const listener = () => {
    const overlay = document.querySelector('.overlay')
    const header = document.querySelector('.cabecalho-paginas')

    const fecharOpcao = () => {
      const dropCarrinho = document.querySelector('.area-cart')
      const dropUsuario = document.querySelector('.area-user')
      const overlay = document.querySelector('.overlay')

      if (dropCarrinho) dropCarrinho.classList.remove('active')
      if (dropUsuario) dropUsuario.classList.remove('active')
      if (overlay) overlay.classList.remove('active')
      setShowZipcodeBox(false)
    }

    if (overlay && header) {
      document.querySelector('.overlay').addEventListener('click', fecharOpcao)
      document
        .querySelector('.cabecalho-paginas')
        .addEventListener('click', fecharOpcao)
    }
  }

  return (
    <HeaderDefault
      sidebar={sidebar}
      setSidebar={setSidebar}
      logado={logado}
      activeDropdownUser={activeDropdownUser}
      hideDropdownUser={hideDropdownUser}
      showZipcodeBox={showZipcodeBox}
      setShowZipcodeBox={setShowZipcodeBox}
      initialColor={initialColor}
      finalColor={finalColor}
      textColor={textColor}
      buttonColor={buttonColor}
      isBlackFridayTheme={isBlackFridayTheme}
      baseColor={baseColor}
      buttonCartTextColor={buttonCartTextColor}
    />
  )
}
